// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeSelectionFieldAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { action, observable } from 'mobx';
import { compose, withProps, withHandlers } from 'recompose';
import { map, curry, every, some, forEach } from 'lodash/fp';

const mapWithIndex = map.convert({ cap: false });

export default compose(
  withProps(props => ({
    treeData: buildTree(props.data)
  })),
  withHandlers({
    onChange: action(curry(onChange))
  })
);

function buildTree(data) {
  return mapWithIndex(
    (item, index) => getNodeData(item, getNodesData(item), `${item.id}_${item.name}`, 'QuerySource', index),
    data
  );
}

function getNodesData(node) {
  return mapWithIndex(
    (field, index) => getNodeData(field, [], `${node.name}_${field.id}_${field.name}`, 'Field', index),
    node.fields
  );
}

function getNodeData(node, nodes, key, type, index) {
  return observable({
    key,
    index,
    value: node.name,
    nodes,
    checked: false,
    nodeType: type,
    indeterminate: false
  });
}

function onChange(props, item, parent) {
  item.checked = !item.checked;

  if (item.nodeType === 'Field') {
    const parentNode = parent.data;
    parentNode.checked = every('checked', parentNode.nodes);
    parentNode.indeterminate = parentNode.checked ? false : some('checked', parentNode.nodes);
  } else if (item.nodeType === 'QuerySource') {
    item.indeterminate = false;
    forEach(node => {
      node.checked = item.checked;
    }, item.nodes);
  }

  onChangedData(props);
}

function onChangedData(props) {
  const result = [];
  forEach(querySource => {
    forEach(field => {
      if (field.checked) {
        result.push({
          field: field.index,
          querySource: querySource.index
        });
      }
    }, querySource.nodes);
  }, props.treeData);

  props.onChangeData(result);
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.TreeSelectionFieldAction.js